import Vue from 'vue'
import App from './App'
import router from './router'
import api from './api'
import MetaInfo from 'vue-meta-info'
import store from './store'
// antd
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// ------------ 全局组件注册 Start ------------ //
import components from '@/components'
// ------------ 全局组件注册 End ------------ //
// 引入项目样式文件
// import './assets/style/app.less'
// 引入工具样式文件
// import './assets/style'
// 解决兼容性问题
import 'babel-polyfill'
import scroll from 'vue-seamless-scroll'
import vueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
// Vue.use(Swiper)
Vue.use(vueAwesomeSwiper)
Vue.use(scroll)

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.use(MetaInfo)
Vue.use(Antd)
Vue.use(components)
Vue.prototype.$api = api
Vue.prototype.$imgUrl = 'https://doc1.huamengtech.com/a/hml/document/downloadByFileId/'
// 添加全局的 eventBus
Vue.prototype.$bus = new Vue()

/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted () {
    document.dispatchEvent(new Event('custom-render-trigger'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js